import React, { useState, useEffect } from 'react';
import './DentalGallerySlider.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Import your dental clinic images here
import clinic1 from './assets/clinic8.jpg';
import clinic2 from './assets/clinic9.jpg';
import clinic3 from './assets/clinic10.jpg';
import clinic4 from './assets/clinic11.jpg';
import clinic5 from './assets/clinic12.jpg';
import clinic6 from './assets/clinic13.jpg';
import clinic7 from './assets/clinic14.jpg';
import clinic8 from './assets/clinic15.jpg';
/*
import clinic8 from './assets/clinic8.jpg';
*/

const DentalGallerySlider = () => {
    const [currentIndex, setCurrentIndex] = useState(2); // Start at index 2 (middle)
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);
    
    const images = [
        { id: 1, src: clinic1, alt: "Dental Clinic Interior 1", title: "Advanced Dental Instruments" },
        { id: 2, src: clinic2, alt: "Dental Clinic Interior 2", title: "Modern Dental Treatment Room" },
        { id: 3, src: clinic3, alt: "Dental Clinic Interior 3", title: "Precision Dental Equipment" },
        { id: 4, src: clinic4, alt: "Dental Clinic Interior 4", title: "State-of-the-Art Dental Facility" },
        { id: 5, src: clinic5, alt: "Dental Clinic Interior 5", title: "Advanced Dental Handpiece Technology" },
        { id: 6, src: clinic6, alt: "Dental Clinic Interior 6", title: "Professional Surgical Instruments" },
        { id: 7, src: clinic7, alt: "Dental Clinic Interior 7", title: "Welcoming Patient Reception" },
        { id: 7, src: clinic8, alt: "Dental Clinic Interior 8", title: "Premium Dental Instrument Kits" },
        /*
        { id: 8, src: clinic8, alt: "Dental Clinic Interior 8", title: "Kids Play Area" }
         */
    ];

    useEffect(() => {
        let interval;
        if (isAutoPlaying) {
            interval = setInterval(() => {
                nextSlide();
            }, 4000);
        }
        return () => clearInterval(interval);
    }, [isAutoPlaying, currentIndex]);

    const nextSlide = () => {
        setIsAutoPlaying(false);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setIsAutoPlaying(false);
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const getVisibleImages = () => {
        const totalImages = images.length;
        const prevIndex = (currentIndex - 1 + totalImages) % totalImages;
        const nextIndex = (currentIndex + 1) % totalImages;
        const prevPrevIndex = (currentIndex - 2 + totalImages) % totalImages;
        const nextNextIndex = (currentIndex + 2) % totalImages;

        return {
            prevPrev: images[prevPrevIndex],
            prev: images[prevIndex],
            current: images[currentIndex],
            next: images[nextIndex],
            nextNext: images[nextNextIndex]
        };
    };

    const visibleImages = getVisibleImages();

    return (
        <div className="dental-gallery">
            <div className="gallery-container">
                <div className="gallery-header">
                    <h2 className="gallery-title">Patient Experience</h2>
                    <p className="gallery-subtitle">
                        Thank you for your referrals. We love hearing about how we helped you.
                    </p>
                </div>

                <div className="slider-container">
                    <button className="nav-btn prev-btn" onClick={prevSlide}>
                        <FaChevronLeft />
                    </button>

                    <div className="slider-wrapper">
                        <div className="slider-track">
                            {/* Far Left (smallest) */}
                            <div className="slide slide-far-left">
                                <img src={visibleImages.prevPrev?.src} alt={visibleImages.prevPrev?.alt} />
                                <div className="slide-overlay">
                                    <span className="slide-title">{visibleImages.prevPrev?.title}</span>
                                </div>
                            </div>

                            {/* Left (medium) */}
                            <div className="slide slide-left">
                                <img src={visibleImages.prev?.src} alt={visibleImages.prev?.alt} />
                                <div className="slide-overlay">
                                    <span className="slide-title">{visibleImages.prev?.title}</span>
                                </div>
                            </div>

                            {/* Center (full width - main focus) */}
                            <div className="slide slide-center">
                                <img src={visibleImages.current?.src} alt={visibleImages.current?.alt} />
                                <div className="slide-overlay">
                                    <span className="slide-title">{visibleImages.current?.title}</span>
                                </div>
                            </div>

                            {/* Right (medium) */}
                            <div className="slide slide-right">
                                <img src={visibleImages.next?.src} alt={visibleImages.next?.alt} />
                                <div className="slide-overlay">
                                    <span className="slide-title">{visibleImages.next?.title}</span>
                                </div>
                            </div>

                            {/* Far Right (smallest) */}
                            <div className="slide slide-far-right">
                                <img src={visibleImages.nextNext?.src} alt={visibleImages.nextNext?.alt} />
                                <div className="slide-overlay">
                                    <span className="slide-title">{visibleImages.nextNext?.title}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button className="nav-btn next-btn" onClick={nextSlide}>
                        <FaChevronRight />
                    </button>
                </div>

                {/* Thumbnail Navigation */}
                <div className="thumbnail-nav">
                    {images.map((image, index) => (
                        <div
                            key={image.id}
                            className={`thumbnail ${currentIndex === index ? 'active' : ''}`}
                            onClick={() => {
                                setIsAutoPlaying(false);
                                setCurrentIndex(index);
                            }}
                        >
                            <img src={image.src} alt={image.alt} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DentalGallerySlider;